<app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray"></app-sg-aria-message>

<h1 *ngIf="task != MODE_UPDATE">サービサー委託対象検索画面</h1>
<h1 *ngIf="task == MODE_UPDATE">サービサー返却検索画面</h1>

<form [formGroup]="searchReqForm" (ngSubmit)="search()">
  <!-- 検索条件コンポーネント -->
  <app-sgke380d-search-condition *ngIf="responseSgke903a" [task]="task" [searched]="searched"
    [cmpnyAreaList]="cmpnyAreaList" [cmpnyAreaInit]="cmpnyAreaInit" (onClickSearchEvent)="search()"
    (onClickClearEvent)="clear()">
  </app-sgke380d-search-condition>
</form>

<!-- 検索結果コンポーネント -->
<app-sgke380d-search-result [task]="task" *ngIf="this.searched" [responseList]="searchResultList"
  [codeConversionMstMap]="codeConversionMstMap" (onClickTargetRegistEvent)="updateTarget($event)"
  (onClickRelocationResearchResistEvent)="updateRelocationResearch($event)"
  (onClickRecnsgnResistEvent)="updateRecnsgn($event)" (onClickBillingPortalEvent)="onClickBillingPortal($event)">
</app-sgke380d-search-result>